import { Tab } from '@headlessui/react'
import Badge from '../components/Badge'

type TabProps = {
  menus: { title: string, value: string, isNew?: boolean }[]
  onChanged: (idx: number) => {}
  selectedIndex: number
  isEmptyReason: boolean
}

function classNames(...classes : any) {
  return classes.filter(Boolean).join(' ')
}

const TabMenu = ({ 
  menus, 
  selectedIndex = 0, 
  onChanged,
  isEmptyReason = false
} : TabProps) => (
  <Tab.Group
    onChange={onChanged}
    defaultIndex={selectedIndex}
    key={selectedIndex}>
    <Tab.List className="flex py-2 bg-white">
      {menus.map((menu, idx) => (
        <Tab
          key={menu.value}
          disabled={menu.value === 'reason_code' && isEmptyReason}
          className={({ selected }) =>
            classNames(
              'py-2 w-full text-base leading-5 font-bold text-blue-700 border-blue-700 border border-r-0 disabled:text-gray-400 disabled:border-gray-400',
              selected ? 'bg-blue-100' : 'text-blue-700 hover:bg-blue-100',
              ' first:rounded-l last:rounded-r last:border-r'
            )
          }
        >
          <span>{menu.isNew ? <Badge variant=' bg-red-500 text-xs text-white'>NEW</Badge> : null} {menu.title}</span>
        </Tab>
      ))}
    </Tab.List>
  </Tab.Group>
)

export default TabMenu